const navTop = document.querySelector('nav.top.navbar');
const navTopNavbar = navTop ? navTop.querySelector('#navbarNav') : null;
const navTopToggler = navTop ? navTop.querySelector('.navbar-toggler') : null;
const navTopLogoContainer = navTop ? navTop.querySelector('.jsNavbarBrand') : null;
const navTopLogo = navTopLogoContainer ? navTopLogoContainer.querySelector('img') : null;
const navTopHeader = document.querySelector('.topHeader');
const megaNavMenus = navTop ? navTop.querySelectorAll('.navbar-nav > .dropdown:not(.languageDropdown):not(.countryDropdown):not(.currencyDropdown):not(.customerLoginDropdown) > .dropdown-toggle + .dropdown-menu') : [];
if (navTop) {
  const navItems = document.querySelectorAll('.nav-item:not(.dropdown)');
  if (navTopNavbar) {
    const bsCollapse = new bootstrap.Collapse(navTopNavbar, {
      toggle: false
    });
    navItems.forEach(link => link.addEventListener('click', () => bsCollapse.hide()));
  }
  if (navTopToggler) {
    navTopToggler.addEventListener('click', () => {
      if (navTopToggler.classList.contains('collapsed')) {
        navTop.style.overflowY = 'visible';
      } else {
        navTop.style.overflowY = 'scroll';
      }
    });
  }
  if (navTop.classList.contains('logoBreakFrame') && navTopToggler) {
    navTopToggler.addEventListener('click', () => {
      if (navTopToggler.classList.contains('collapsed')) {
        navTopLogo.classList.remove("h-100");
        navTopLogo.classList.add("w-100");
        navTopLogo.style.maxWidth = '100%';
        navTopLogoContainer.style.height = 'auto';
        navTopLogoContainer.style.display = 'inline';
      } else {
        navTopLogo.classList.remove("w-100");
        navTopLogo.classList.add("h-100");
        navTopLogo.style.maxWidth = 'none';
        navTopLogoContainer.style.height = '50px';
        navTopLogoContainer.style.display = 'block';
      }
    });
  }
  if (navTop.classList.contains('mega') && megaNavMenus.length > 0) {
    const setMegaMenuOffset = () => {
      let offset = navTop.offsetHeight;
      if (navTopHeader) {
        offset += navTopHeader.offsetHeight;
      }
      megaNavMenus.forEach(megaNavMenu => {
        megaNavMenu.style.top = `${offset}px`;
      });
    };
    setMegaMenuOffset();
    window.addEventListener('resize', setMegaMenuOffset);
  }
}